/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Role_Update_FailedInputs */

const en_admin_user_detail_role_update_failed = /** @type {(inputs: Admin_User_Detail_Role_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update role`)
};

const de_admin_user_detail_role_update_failed = /** @type {(inputs: Admin_User_Detail_Role_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle konnte nicht aktualisiert werden`)
};

/**
* | output |
* | --- |
* | "Failed to update role" |
*
* @param {Admin_User_Detail_Role_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_role_update_failed = /** @type {((inputs?: Admin_User_Detail_Role_Update_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Role_Update_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_role_update_failed(inputs)
	return en_admin_user_detail_role_update_failed(inputs)
});